import { render, staticRenderFns } from "./BranchStock.vue?vue&type=template&id=2ea6f350&"
import script from "./BranchStock.vue?vue&type=script&lang=js&"
export * from "./BranchStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports